import type { FC } from 'react';
import { usePipelineStyles } from './pipelineStyles';
import type { PipelineEdge as PipelineEdgeType } from './pipelineTypes';

interface PipelineEdgeProps {
  edge: PipelineEdgeType;
}

export const PipelineEdge: FC<PipelineEdgeProps> = ({ edge }) => {
  const classes = usePipelineStyles();

  const lastLine = edge.lines[edge.lines.length - 1];

  return (
    <>
      {edge.lines.map((line, i) => {
        const dx = line.x2 - line.x1;
        const dy = line.y2 - line.y1;
        const length = Math.sqrt(dx * dx + dy * dy);
        const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        const midX = (line.x1 + line.x2) / 2;
        const midY = (line.y1 + line.y2) / 2;

        return (
          <div
            key={i}
            className={classes.edgeLine}
            style={{
              width: length,
              left: midX - length / 2,
              top: midY,
              transform: `rotate(${angle}deg)`,
            }}
          />
        );
      })}

      {lastLine && (
        <div
          className={classes.arrowHead}
          style={{
            left: lastLine.x2 - 6,
            top: lastLine.y2 - 4,
          }}
        />
      )}
    </>
  );
};
